import { render, staticRenderFns } from "./modalMedia.vue?vue&type=template&id=05c35d5d"
import script from "./modalMedia.vue?vue&type=script&lang=js"
export * from "./modalMedia.vue?vue&type=script&lang=js"
import style0 from "./modalMedia.vue?vue&type=style&index=0&id=05c35d5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports